import Vue from "vue";
import axios from "axios";
import router from "@/router";
import qs from "qs";
import merge from "lodash/merge";
import { clearLoginInfo } from "@/utils";

const http = axios.create({
  //timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8"
  }
});

/**
 * 请求拦截
 */
http.interceptors.request.use(
  config => {
    config.headers["iotAuthorization"] = Vue.cookie.get("iotAuthorization"); // 请求头带上token
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截
 */
http.interceptors.response.use(
  response => {
    if (response.data && response.data.code == 401) {
      // 401, JWT token失效
      sessionStorage.clear();
      clearLoginInfo();
      router.push({ name: "login" });
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = actionName => {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  return "https://c.szwandi.cn/iotApi/" + actionName;
  // return "http://192.168.0.57:8098/iotApi/" + actionName;
  // return "http://192.168.0.53:8098/iotApi/" + actionName;
  // return "http://8.134.74.245:8098/" + actionName;
  // return "https://test.szwandi.cn/iotApi/" + actionName;
  // return "http://test.szwandi.cn:8099/iotApi/" + actionName;
};

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefaultParams = false) => {
  let defaults = {
    t: new Date().getTime()
  };
  return openDefaultParams ? merge(defaults, params) : params;
};

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 **/
http.adornData = (
  data = {},
  openDefaultParams = false,
  contentType = "json"
) => {
  let defaults = {
    t: new Date().getTime()
  };
  data = openDefaultParams ? merge(defaults, data) : data;
  return contentType === "json" ? JSON.stringify(data) : qs.stringify(data);
};

export default http;



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js